export default "__VITE_ASSET__DZIJxpUD__"